import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Title } from 'app/components';
import React, { useEffect, useState } from 'react';
import { API } from 'app/services';
import { useAsyncTask, useRouter } from 'app/utils';
import { DocumentListingComp } from './components';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 3, 8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 6),
    },
  },
}));

const DocumentListing = ({ routeType = 'account' }) => {
  const classes = useStyles();
  const router = useRouter();
  const access = useSelector((state) => state.profile.access);
  const { match } = router;
  const { params } = match;
  const [runLoadDocumentList] = useAsyncTask('listDocuments');
  const [documentListData, setDocumentListData] = useState(null);

  useEffect(() => {
    if (access && access.token)getDocumentList();
  }, [access]);

  const getDocumentList = () => {
    runLoadDocumentList(async () => {
      const loader = routeType === 'account' ? API.Screening.list_documents : API.Admin.list_verify_document;
      const { models } = await loader({ limit: 1, offset: 0 });
      if (models && models.length > 0) {
        setDocumentListData(models);
      }
    });
  };

  if (!documentListData) return null;

  const isRegtank = documentListData[0]?.screen_provider_id;

  return (
    <Box className={classes.root}>
      <Title prefix="Documents" />
      <DocumentListingComp routeType={routeType} />
    </Box>
  );
};

export default DocumentListing;
